import { render, staticRenderFns } from "./SortMenu.vue?vue&type=template&id=0ef53085&"
import script from "./SortMenu.vue?vue&type=script&lang=js&"
export * from "./SortMenu.vue?vue&type=script&lang=js&"
import style0 from "./SortMenu.vue?vue&type=style&index=0&id=0ef53085&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports